<template>
  <div style="height: 100%;overflow: auto;">
    <div style="display: flex;margin-bottom: 20px;">
      <el-button type="primary" @click="page_add">添加单页</el-button>
      <el-input v-model="keyword" placeholder=标题名称 style="width: 250px;margin: 0 10px;"></el-input>
      <el-button type="primary" @click="get_list" >搜索</el-button>
    </div>
    <div>
      <div :class="sort_id==0 ? 'sort select_sort' : 'sort'" @click="change_sort(0)">默认</div>
      <div v-for="(val) in sort_list" :key="val" :class=" sort_id==val.id ? 'sort bl select_sort' : 'sort bl'"
           @click="change_sort(val.id)">{{val.title}}</div>
    </div>
    <el-row>
<!--      <el-col >-->
<!--        <el-card :body-style="{ padding: '0px' }" shadow="hover">-->
<!--          <div class="iconfont icon-add" @click="page_add"></div>-->
<!--        </el-card>-->
<!--      </el-col>-->
      <el-col v-for="(val) in list" :key="val" >
        <el-card :body-style="{ padding: '10px' }" shadow="hover">
          <div style="display: flex">
            <div class="img"
                 :style="{'background':'url('+val.cover+') no-repeat center','background-size': 'cover'}"
                 @click="page_edit(val.id)"></div>
            <div style="width: 260px;">
              <div class="title">{{val.title}}</div>
              <div class="mb-10" style="display: flex;align-items: center;">
                <el-tag type="success" size="small" v-if="val.is_show==0" class="mr-10">下架中</el-tag>
                <el-tag type="success" size="small" v-if="val.is_show==1" class="mr-10">上架中</el-tag>
                <el-tag type="danger" class="ml-10" size="small" v-if="val.is_stop_contact==1">禁止联系</el-tag>
                <div style="flex: 1"></div>
                <el-popconfirm title="确定上架？" @confirm="show(val.id,'1')" v-if="val.is_show==0">
                  <el-button slot="reference" type="danger" size="mini">上架
                  </el-button>
                </el-popconfirm>
                <el-popconfirm title="确定下架？" @confirm="show(val.id,'0')" v-if="val.is_show==1">
                  <el-button type="danger" size="mini" slot="reference">下架
                  </el-button>
                </el-popconfirm>
              </div>
              <div style="display: flex;margin: 20px auto;">
<!--                <el-tag type="success" size="small" v-if="val.is_read==1">状态：可浏览</el-tag>-->
<!--                <el-tag type="danger" size="small" v-if="val.is_read==0">状态：不可浏览</el-tag>-->
                <div style="flex:1"></div>
                <el-button type="danger" size="mini" slot="reference" class="ml-10" @click="form_show(val.id,val.form_content)">表单
                </el-button>
                <el-button slot="reference" type="danger" size="mini"  @click="share_join(val.id)">推广
                </el-button>
              </div>
<!--              <div v-if="val.look_type==1" class="mb-10" style="display: flex;align-items: center">-->
<!--                <el-tag type="primary" class="w-100" size="small">可用次数: {{(val.all_num-val.use_num)}}</el-tag>-->
<!--                <div style="flex: 1;"></div>-->
<!--                <el-button slot="reference" type="danger" size="mini" class="ml-10" @click="send(val.id)">增加-->
<!--                </el-button>-->
<!--                <el-button slot="reference" type="danger" size="mini" class="ml-10"-->
<!--                           @click="decrease(val.id,val.all_num-val.use_num)">减少-->
<!--                </el-button>-->
<!--              </div>-->
<!--              <div v-if="val.look_type==2" style="font-size: 15px;margin:12px 0 12px 5px;">限制时间：{{val.start_time
                +' ~ '+ val.end_time}}</div>-->
              <div class="wx-user" v-if="val.user">
                <div class="avatarurl" :style="{ backgroundImage:'url('+val.user.avatarurl+')' }"></div>
                <div class="nickname">{{val.user.nickname}}</div>
                <el-popconfirm title="确认操作？" @confirm="unbind_user(val.id)">
                  <el-button type="text" size="mini" slot="reference">取消绑定</el-button>
                </el-popconfirm>
              </div>
              <div class="wx-user" v-if="!val.user">
                <el-tag type="info" size="small">未绑定用户</el-tag>
                <el-button type="text" size="small" style="margin-left: 10px;" @click="bind_user(val.id)">绑定</el-button>
              </div>
              <div style="font-size: 12px;margin: 5px 0 0 3px;display: flex;align-items: center">
                阅读量：{{val.use_num}}
                <span style="margin-left: 10px;">浏览量：{{val.look_num}}</span>
                <div style="flex: 1"></div>
                <el-popconfirm title="确定删除？" @confirm="del(val.id)">
                  <el-tag type="danger" size="small" slot="reference">删除</el-tag>
                </el-popconfirm>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div style="height: 60px;"></div>
    <layer-page :total="total" :currentPage="page" @change="page_change"></layer-page>
    <div class="bg" v-if="is_bind">
      <div class="wrap">
        <div class="pop-title-closed">
          <div class="pop-title">绑定用户</div>
          <div class="pop-closed iconfont icon-close" @click="pop_close"></div>
        </div>
        <div class="contain">
          <div class="image"><img :src="qrcode_url" alt="" mode="widthFix"/></div>
          <div class="save" @click="qrcode_save(qrcode_url)">保存图片</div>
        </div>
      </div>
    </div>
    <LayerPop :title="pop_type=='form' ? '添加/编辑表单' : '推广列表'" @close="vue_pop_show_hide" v-if="is_pop">
      <div v-if="pop_type=='form'">
        <el-button type="primary" round size="medium" @click="add">添加项目</el-button>
        <el-table :data="form_content" border stripe style="margin: 20px auto">
          <el-table-column label="名称" >
            <template v-slot="scope">
              <el-input type="text" v-model.number="scope.row.title" placeholder="名称"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="提示" >
            <template v-slot="scope">
              <el-input type="text" v-model.number="scope.row.tip" placeholder="提示"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="类型" >
            <template v-slot="scope">
              <el-select v-model="scope.row.type" placeholder="请选择">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作" >
            <template v-slot="scope">
              <el-popconfirm title="确定删除此行？" @confirm="del_form(scope.$index)">
                <el-button size="mini" type="danger" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="primary" size="medium" @click="save">确认保存</el-button>
      </div>
      <div v-if="pop_type=='join'">
        <el-table :data="join_list" border stripe>
          <el-table-column label="ID" prop="id"></el-table-column>
          <el-table-column label="绑定微信用户">
            <template v-slot="scope">
              <div class="wx-user" v-if="scope.row.user">
                <div class="avatarurl" :style="{ backgroundImage:'url('+scope.row.user.avatarurl+')' }"></div>
                <div class="nickname">{{scope.row.user.nickname}}</div>
              </div>
              <div class="wx-user" v-if="!scope.row.user">
                暂无绑定用户
              </div>
            </template>
          </el-table-column>
          <el-table-column label="申请人" prop="name"></el-table-column>
          <el-table-column label="手机号码" prop="phone"></el-table-column>
          <el-table-column label="地址" prop="">
            <template slot-scope="scope"> {{scope.row.city}}{{scope.row.address}} </template>
          </el-table-column>
          <el-table-column label="申请时间" prop="addtime_format"></el-table-column>
          <el-table-column label="审核状态" prop="">
            <template v-slot="scope">
              <el-tag type="success" size="small" v-if="scope.row.is_pass==1">通过</el-tag>
              <el-tag type="info" size="small" v-if="scope.row.is_pass==0">未审核</el-tag>
              <el-tag type="danger" size="small" v-if="scope.row.is_pass==2">不通过</el-tag>
              <template v-if="scope.row.is_pass ==0">
                <el-popconfirm title="确定审核通过？" @confirm="join_check(scope.row.id,'1')">
                  <el-button slot="reference" type="text" size="small" class="ml-10">通过</el-button>
                </el-popconfirm>
                <el-popconfirm title="确定不通过？" @confirm="join_check(scope.row.id,'2')">
                  <el-button type="text" size="small" slot="reference" class="ml-10">不通过</el-button>
                </el-popconfirm>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="审核时间" prop="check_time_format"></el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <el-popconfirm title="确认操作？" @confirm="join_check(scope.row.id,'1',scope.$index)"
                             v-if="scope.row.is_pass==2">
                <el-button type="danger" size="small" slot="reference" style="margin-right: 10px;">重新通过</el-button>
              </el-popconfirm>
              <el-popconfirm title="确认操作？" @confirm="join_check(scope.row.id,'2',scope.$index)" v-if="scope.row.is_pass==1">
                <el-button type="danger" size="small" slot="reference" style="margin-right: 10px;">不通过</el-button>
              </el-popconfirm>
              <!--            <el-popconfirm title="确认删除？" @confirm="join_del(scope.row.id)">
                            <el-button type="danger" size="small" slot="reference">删除</el-button>
                          </el-popconfirm>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </LayerPop>
  </div>
</template>

<script>
import LayerPage from "@/components/layer-page";
import LayerPop from "@/components/layer-pop";

export default {
  name: "page_list",
  components:{LayerPage,LayerPop},
  data() {
    return {
      list:[],
      is_load:false,
      page:1,
      total:0,
      is_bind:false,
      keyword:'',
      is_pop:false,
      form_content: [],
      options:[
        {value: 'text',label: '文本'},
        {value: 'phone',label: '手机号'},
        {value: 'img',label: '图片'},
      ],
      id:0,
      pop_type:'',
      join_list:[],
      sort_list:[],
      sort_id:0
    };
  },
  mounted: async function() {
    try {
      await this.get_sort_list();
      await this.get_list();
      // this.joininfo();
    }catch (e) {
      console.log(e)
    }
  },
  methods:{
    share_join:async function (id){
      console.log(id);
      let that = this;
      this.pop_type = 'join';
      this.$_showLoading();
      let res = await this.$_api.page('get_join_list', {id:id});
      this.$_hideLoading();
      this.join_list = res.list;
      that.is_pop = true;
    },
    join_check: async function (id, val,key) {
      try {
        console.log(key);
        this.$_showLoading();
        let res = await this.$_api.page('check', {id: id, val: val});
        this.$_hideLoading();
        this.$_showToast(res.errmsg, res.style);
        if (res.errcode == 0) {
          this.join_list[key].is_pass = val;
        }
      } catch (e) {
        console.log(e);
      }
    },
    page_change : async function  (e){
      try{
        this.page = e;
        this.is_load = false;
        this.list = [];
        await this.get_list();
      }catch (e){
        console.log(e);
        return false;
      }
    },
    form_show(id,form_content){
      console.log(id);
      console.log(form_content);
      this.pop_type = 'form';
      this.is_pop = true;
      this.id = id;
      this.form_content = form_content;
    },
    del_form:function (index){
      console.log(index);
      this.form_content.splice(index,1);
    },
    add: function (){
      let data = {title:'',type:'text',tip:'',value:''};
      this.form_content.push(data);
    },
    save: async function (){
      this.$_showLoading();
      let res = await this.$_api.page('form_edit', {id : this.id,form_content:this.form_content});
      if(res.errcode == 0){
        this.$_showToast(res.errmsg,res.style);
        this.get_list();
      }else{
        this.$_showToast(res.errmsg,res.style);
      }
      this.$_hideLoading();
    },
    page_add:function (){
      this.$router.push('one_page_detail');
    },
    page_edit:function(id){
      this.$router.push({path:'/one_page_detail',query:{id:id}});
    },
    get_sort_list:async function(){
      let res = await this.$_api.page('sort_list',
          {page:1,size:100,uid:this.user.uid});
      if(res.errcode == 0){
        this.sort_list = res.list;
      }
    },
    get_list:async function (){
      if (!this.is_load){
        this.is_load = true;
        this.$_showLoading();
        let res = await this.$_api.page('get_list',
            {page : this.page,uid:this.user.uid,keyword:this.keyword,sort_id:this.sort_id});
        this.is_load = false;
        this.$_hideLoading();
        this.list = res.list;
        this.total = res.total;
      }
    },
    change_sort:function (id){
      this.sort_id = id;
      this.get_list();
    },
    joininfo:async function (){
      let that = this;
      let res = await this.$_api.admin('joininfo', {uid:this.user.uid,});
      that.$store.state.user.use_num = res.use_num;
      that.$_vueVuex('user',that.$store.state.user);
    },
    show:async function (id,val){
      try {
        this.$_showLoading();
        let res = await this.$_api.page('show',{id : id, val:val});
        this.$_hideLoading();
        this.$_showToast(res.errmsg,res.style);
        if(res.errcode == 0){
          await this.get_list();
        }
      }catch (e){
        console.log(e);
      }
    },
    send:async function (id){
      let that = this;
      console.log(id);
      let rs = await this.$_prompt('增加次数', '提示', /^[1-9]\d*$/, '请输入大于0')
      if(rs){
        this.$_showLoading();
        let res = await that.$_api.company('do_send',{one_page_id : id,uid:this.user.uid,use_num:rs});
        this.$_hideLoading();
        this.$_showToast(res.errmsg,res.style);
        if(res.errcode == 0){
          that.get_list();
          that.$store.state.user.use_num = res.use_num;
          that.$_vueVuex('user',that.$store.state.user);
        }
      }
    },
    decrease:async function (id,num){
      let that = this;
      console.log(id);
      let rs = await this.$_prompt('减少次数', '提示', /^[1-9]\d*$/, '请输入大于0')
      if(rs){
        if(num<rs){
          this.$_showToast('可用次数不足','error');
          return;
        }
        this.$_showLoading();
        let res = await that.$_api.company('do_decrease',{ebook_id : id,uid:this.user.uid,use_num:rs});
        this.$_hideLoading();
        this.$_showToast(res.errmsg,res.style);
        if(res.errcode == 0){
          that.get_list();
          that.$store.state.user.use_num = res.use_num;
          that.$_vueVuex('user',that.$store.state.user);
        }
      }
    },
    del:async function (id){
      try{
        let that = this;
        that.$_showLoading();
        let res =await that.$_api.page('del',{id:id});
        that.$_hideLoading();
        that.$_showToast(res.errmsg,res.style);
        if(res.errcode == 0){
          await this.get_list();
        }
      }catch (e) {
        console.log(e)
      }
    },
    bind_user:async function (id){
      try{
        console.log(id);
        if (id){
          this.$_showLoading();
          let res = await this.$_api.page('qrcode_to_bind', {id : id});
          this.$_hideLoading();
          if (res.errcode == 0){
            this.qrcode_url = res.url;
            this.is_bind = true;
          }else{
            this.$_showToastNone(res.errmsg);
          }
        }
      }catch (e){
        console.log(e);
        return false;
      }
    },
    unbind_user:async function (id){
      try {
        console.log(id);
        if (id){
          this.$_showLoading();
          let res = await this.$_api.page('un_bind', {id : id});
          this.$_hideLoading();
          this.$_showToast(res.errmsg,res.style);
          if (res.errcode == 0){
            this.is_load = false;
            this.get_list();
          }
        }
      }catch (e){
        console.log(e);
        return false;
      }
    },
    pop_close:function (){
      this.is_bind = false;
    },
    qrcode_save : function  (url){
      window.open(url);
    },
  }
}
</script>

<style scoped>
.el-col{width: 450px;margin-right: 14px;margin-bottom: 30px;}
.el-card{height: 220px; cursor: pointer;border-radius: 10px;}
.title{
  font-weight: bold;
  font-size: 20px;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  margin-bottom: 10px;
}
.icon-add{
  height: 420px;
  line-height: 420px;
  text-align: center;
  font-size: 80px;
  color: #ddd;
}
.img{
  width: 150px;
  height: 200px;
  border-radius: 5px;
  margin-right: 10px;
}

.wx-user { display: flex;align-items: center; height: auto; overflow-x: hidden; vertical-align: middle; line-height:
    30px; }
.avatarurl { width: 30px; height: 30px; border-radius: 20px; overflow-x: hidden; background: #f2f2f2 no-repeat center; background-size: cover; }
.nickname { padding-left: 5px; font-size: 14px; line-height: 30px;flex: 1; white-space:nowrap;
  overflow:hidden;text-overflow:ellipsis;}
.cover{width: 100px;height: 100px;background: #f2f2f2 no-repeat center;background-size: cover; }

.bg{position: fixed; z-index: 9999; left: 0; right: 0; top: 0; bottom: 0; background: rgba(0,0,0,0.2);}
.wrap{ position: fixed; z-index: 10000; width: 500px; background: #ffffff; border-radius: 5px;
  overflow:hidden; box-shadow: 0 0 30px #666666; left: 50%; top:50% ;margin-left: -250px;transform:
    translateY(-50%);}
.pop-title-closed { height: 39px; line-height: 39px; border-bottom: 1px solid #dcdfe6; padding: 0 20px; display: flex; }
.pop-title { flex: 1; padding-right: 20px; }
.pop-closed { font-size: 24px; color: #999999; cursor: pointer; }
.contain { width: 460px; padding: 20px; overflow-x: hidden; overflow-y: auto; }

.image { width: 400px; padding-bottom: 30px; margin:auto; }
.image img { width: 400px; height: 400px;}
.save { width: 120px; height: 40px; line-height: 40px; text-align: center; background: #5dbb85; color: #ffffff; border-radius: 5px; margin: auto; cursor: pointer; }

.sort{
  display: inline-block;
  padding: 1px 20px;
  margin: 10px 10px 30px 0;
  color: #999;
  cursor: pointer;
  font-size: 18px;
}
.bl{ border-left: 1px solid #ddd;}
.select_sort{
  color: #409EFF;
}
</style>